export const CaptionTextFieldLength = {
  '&.captionTextField .MuiOutlinedInput-root': {
    width: '20rem',
  },
};
